import { render, staticRenderFns } from "./VocationPersons1Section.vue?vue&type=template&id=b853f8f6"
import script from "./VocationPersons1Section.vue?vue&type=script&lang=ts"
export * from "./VocationPersons1Section.vue?vue&type=script&lang=ts"
import style0 from "./VocationPersons1Section.vue?vue&type=style&index=0&id=b853f8f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports